<template>
    <div>
        Warehouses
    </div>
</template>

<script>
export default {
    name: "Warehouses",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
